import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const WorkflowFlow = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3551 7.5C11.9248 8.94574 10.5855 10 9 10C7.41449 10 6.07521 8.94574 5.64494 7.5H2V5.5H5.64494C6.07521 4.05426 7.41449 3 9 3C10.5855 3 11.9248 4.05426 12.3551 5.5H16.25C19.4256 5.5 22 8.07436 22 11.25C22 14.218 19.7512 16.6608 16.8645 16.9675C16.4448 18.4299 15.0974 19.5 13.5 19.5C11.9145 19.5 10.5752 18.4457 10.1449 17H6C4.89543 17 4 17.8954 4 19V21H2V19C2 16.7909 3.79086 15 6 15H10.1449C10.5752 13.5543 11.9145 12.5 13.5 12.5C15.0685 12.5 16.3961 13.5318 16.8409 14.9537C18.6312 14.6703 20 13.12 20 11.25C20 9.17893 18.3211 7.5 16.25 7.5H12.3551ZM9 8C9.82843 8 10.5 7.32843 10.5 6.5C10.5 5.67157 9.82843 5 9 5C8.17157 5 7.5 5.67157 7.5 6.5C7.5 7.32843 8.17157 8 9 8ZM13.5 17.5C14.3284 17.5 15 16.8284 15 16C15 15.1716 14.3284 14.5 13.5 14.5C12.6716 14.5 12 15.1716 12 16C12 16.8284 12.6716 17.5 13.5 17.5Z"
      fill="currentColor"
    />
  </Icon>
));

export default WorkflowFlow;
